import { DEFAULT_PIVOT_LIMIT } from "views/Constants";
export const DateType = "time";
export const ValuesType = "values";
const DEFAULT_PIVOT_CONFIG = { limit: DEFAULT_PIVOT_LIMIT, skip_empty_values: false };
export default class Pivot {
  constructor(fields, type, config = DEFAULT_PIVOT_CONFIG) {
    this._value = { fields, type, config };
  }
  get fields() {
    return this._value.fields;
  }
  get type() {
    return this._value.type;
  }
  get config() {
    return this._value.config;
  }
  static create(fields, type, config = DEFAULT_PIVOT_CONFIG) {
    return new Pivot(fields, type, config);
  }
  static createValues(fields, config = DEFAULT_PIVOT_CONFIG) {
    return Pivot.create(fields, ValuesType, config);
  }
  static fromJSON(value) {
    const { fields, type, config = DEFAULT_PIVOT_CONFIG } = value;
    return new Pivot(fields, type, config);
  }
  toJSON() {
    const { fields, type, config } = this._value;
    return { fields, type, config };
  }
}
